import { YCLIENTS_SCENARIO_IDS } from '../constants'

export function isStarterPackScenarioVisible(scenario, hasYClientsConnector) {
    if (YCLIENTS_SCENARIO_IDS.includes(scenario.scenarioId) && !hasYClientsConnector) {
        return false
    }
    return true
}

export function filterVisibleStarterPackScenarios(scenarios, hasYClientsConnector) {
    return scenarios.filter(scenario => isStarterPackScenarioVisible(scenario, hasYClientsConnector))
}
